export default "__VITE_ASSET__COwQH_m1__"